import { CallApi } from "app/_helpers/CallApi/CallApi";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import configureStore from "../../redux/Store";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
let { Store } = configureStore();

export async function getAllCapas(filter) {
  const capaData = Store.getState()?.userManagement?.capa;
  if (!capaData?.data?.data?.length || filter) {
    let url = "/global-configuration/ehs-module/all-capas?";
    if (filter) url += filter;
    try {
      const response = await RestMethod.GET(url);
      if (!filter)
        Store.dispatch({
          type: USER_DATA_CONSTANT.CAPA,
          data: response.data,
        });
      return response.data;
    } catch (error) {
      console.log("error detected while fetching data from api");
      return null;
    }
  } else {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: capaData?.data?.data,
        });
      }, 0);
    });
  }
}

export async function getAllEscalationEventEvent(filter) {
  let url = "/global-configuration/ehs-module/escalation-master-event";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function getEmailTemplateById(id) {
  let url = "/global-configuration/ehs-module/escalation-master-event/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getCapaById(id) {
  let url = "/global-configuration/ehs-module/get-capa-by-id/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createCapa(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-capa",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateCapa(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-capa/" + id,
      data
    );
    if (response.data.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.CAPA,
        data: [],
      });
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateCapaRevert(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-revert-capa/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateEmailTemplate(id, data, filter = false) {
  let url = "/global-configuration/ehs-module/escalation-master-event/" + id;
  if (filter) url += filter;
  try {
    const response = await RestMethod.PUT(url, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function deleteCapa(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-capa/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function approveRejectCapa(id, data) {
  const url = "/global-configuration/ehs-module/capa-approve-reject/" + id;
  return await CallApi(url, "PUT", data);
}

export async function revertedCapa(id, data) {
  let url = "/global-configuration/ehs-module/revert-capa/" + id;

  try {
    const response = await RestMethod.PUT(url, data);
    if (response.data.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.CAPA,
        data: [],
      });
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
